/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePccAdvancedPatientDetailsResponse } from './CreatePccAdvancedPatientDetailsResponse';
import {
    CreatePccAdvancedPatientDetailsResponseFromJSON,
    CreatePccAdvancedPatientDetailsResponseFromJSONTyped,
    CreatePccAdvancedPatientDetailsResponseToJSON,
    CreatePccAdvancedPatientDetailsResponseToJSONTyped,
} from './CreatePccAdvancedPatientDetailsResponse';

/**
 * 
 * @export
 * @interface UploadPccAdvancedPatientDetails200Response
 */
export interface UploadPccAdvancedPatientDetails200Response {
    /**
     * 
     */
    data?: CreatePccAdvancedPatientDetailsResponse;
}

/**
 * Check if a given object implements the UploadPccAdvancedPatientDetails200Response interface.
 */
export function instanceOfUploadPccAdvancedPatientDetails200Response(value: object): value is UploadPccAdvancedPatientDetails200Response {
    return true;
}

export function UploadPccAdvancedPatientDetails200ResponseFromJSON(json: any): UploadPccAdvancedPatientDetails200Response {
    return UploadPccAdvancedPatientDetails200ResponseFromJSONTyped(json, false);
}

export function UploadPccAdvancedPatientDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPccAdvancedPatientDetails200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : CreatePccAdvancedPatientDetailsResponseFromJSON(json['data']),
    };
}

export function UploadPccAdvancedPatientDetails200ResponseToJSON(json: any): UploadPccAdvancedPatientDetails200Response {
    return UploadPccAdvancedPatientDetails200ResponseToJSONTyped(json, false);
}

export function UploadPccAdvancedPatientDetails200ResponseToJSONTyped(value?: UploadPccAdvancedPatientDetails200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreatePccAdvancedPatientDetailsResponseToJSON(value['data']),
    };
}

